import { StripeAddressElementChangeEventValue } from '@/types/checkout';
import { AddressVerificationFragment } from '@/gql';
import { StateCreator } from 'zustand';
import { parseStripeEventNameToFirstLast } from '@/lib/checkout';

export interface CustomerSliceState {
  email?: string;
  customerInfo?: StripeAddressElementChangeEventValue;
  suggestedAddress?: AddressVerificationFragment;
  customerInfoValidated: boolean;
  userConfirmedAddress: boolean;
}

export interface CustomerSliceActions {
  setEmail: (email: string) => void;
  setCustomerInfo: (customerInfo: StripeAddressElementChangeEventValue) => void;
  setSuggestedAddress: (suggestedAddress?: AddressVerificationFragment) => void;
  setCustomerInfoValidated: (customerInfoValidated: boolean) => void;
  setUserConfirmedAddress: (userConfirmedAddress: boolean) => void;
  resetCustomerInfo: () => void;
  clearCustomerInfo: () => void;
}

const defaultState: CustomerSliceState = {
  email: undefined,
  userConfirmedAddress: false,
  customerInfo: undefined,
  customerInfoValidated: false,
};

export type CustomerSlice = CustomerSliceState & CustomerSliceActions;

export const createCustomerSlice: StateCreator<CustomerSlice, [], [], CustomerSlice> = (set) => ({
  ...defaultState,
  setEmail: (email: string) => set({ email }),
  setCustomerInfo: (customerInfo: StripeAddressElementChangeEventValue) => {
    const { firstName, lastName } = parseStripeEventNameToFirstLast(customerInfo.name);
    set({ customerInfo: { ...customerInfo, firstName, lastName } });
  },
  setSuggestedAddress: (suggestedAddress?: AddressVerificationFragment) => set({ suggestedAddress }),
  setCustomerInfoValidated: (customerInfoValidated: boolean) => set({ customerInfoValidated }),
  setUserConfirmedAddress: (userConfirmedAddress: boolean) => set({ userConfirmedAddress }),
  resetCustomerInfo: () => set({ userConfirmedAddress: false, customerInfoValidated: false }),
  clearCustomerInfo: () => set(defaultState),
});
